import React from 'react';

const StudioLeftSidebar = ({ children }) => (
  <aside className="studio-sidebar studio-sidebar-left">
    {children ? children : (
      <>
        <div className="studio-sidebar-title">Left Sidebar</div>
        <div className="studio-sidebar-placeholder">Tools & assets</div>
      </>
    )}
  </aside>
);

export default StudioLeftSidebar;
